import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import redirecionamento from '@/util/redirecionamentoRotasConteudo'
import { BSpinner } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import { mapState } from 'vuex'
import util from '@/util'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'

export default {
  name: 'detalhes-galeriaFotos',
  components: {
    cabecalho,
    menuLateral,
    imageStream,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('auth', ['tipoDeAcesso'])
  },

  data: () => {
    return {
      album: [],
      listaFotosAlbum: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: ''
      },
      idAlbum: null,
      idFoto: null,
      dataHoraFormatada: null,
      publicador: null
    }
  },

  mounted () {
    this.idAlbum = this.$route.params.id
    this.obterAlbum(this.idAlbum)
  },

  methods: {
    async obterAlbum (id) {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/album/' + id)
        this.album = resposta.data.retorno.dados
        this.dataHoraFormatada = this.formatarDataHora(this.album.date)
        this.publicador = this.album.user.f_name

        this.obterFotosDoAlbum(this.idAlbum)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    voltarRotaAnterior () {
      this.$router.push({ name: redirecionamento.obterRota(this.tipoDeAcesso, 'galeriaFotos') })
    },

    showModalExcluirFotosAlbum (id) {
      this.idFoto = id
      this.$bvModal.show('modalExcluir')
    },

    async excluirFotosAlbum () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.delete('/album/foto/' + this.idFoto + '/remover')
        this.definirFlagCarregandoDados(false, '')
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem

        if (this.retorno.sucesso) {
          util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
        }
        this.obterAlbum(this.idAlbum)
      } catch (e) {
        this.definirFlagCarregandoDados(false, '')
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    },

    async obterFotosDoAlbum (id) {
      try {
        const resposta = await this.axios.get('/album/' + id + '/fotos')
        this.listaFotosAlbum = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    formatarDataHora (data) {
      return util.formatarData(data, 'DD/MM/YYYY')
    }
  }
}
